import { render, staticRenderFns } from "./exam-scoring.vue?vue&type=template&id=39af5858&scoped=true"
import script from "./exam-scoring.vue?vue&type=script&lang=ts"
export * from "./exam-scoring.vue?vue&type=script&lang=ts"
import style0 from "./exam-scoring.vue?vue&type=style&index=0&id=39af5858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af5858",
  null
  
)

export default component.exports